import styled from "styled-components";

export const StyledSwitch = styled.div<any>`
  display: flex;
  width: max-content;
  flex-direction: ${(prop) => (prop.horizon ? "row-reverse" : "column")};
  align-items: center;
  gap: ${(prop) => (prop.horizon ? "15px" : "0")};

  label {
    margin-bottom: ${(prop) => (prop.horizon ? "0px" : "20px")};
    svg {
      margin-left: 15px;
      cursor: pointer;
      path {
        transition: all 0.3s ease;
      }
      &:hover {
        path {
          fill: #019ef7;
        }
      }
    }
  }
`;
